import { Mail, Eye, CheckCircle, Trash2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { useAdmin } from './AdminContext';

export const AdminMessagesTab = () => {
  const { contactMessages, apiCall } = useAdmin();

  return (
    <>
      <h2 className="text-xl font-semibold mb-4">Contact Messages ({contactMessages.length})</h2>
      {contactMessages.length === 0 ? (
        <Card className="bg-card border-border">
          <CardContent className="py-12 text-center">
            <Mail size={48} className="mx-auto text-muted-foreground mb-4" />
            <h3 className="text-lg font-semibold mb-2">No messages yet</h3>
            <p className="text-muted-foreground">Messages from the contact form will appear here.</p>
          </CardContent>
        </Card>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {contactMessages.map(message => (
            <Card key={message.id} className="bg-card border-border">
              <CardHeader className="pb-2 space-y-2">
                <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
                  <CardTitle className="text-base sm:text-lg break-words">{message.subject}</CardTitle>
                  <Badge className={`self-start sm:self-auto shrink-0 ${message.status === 'new' ? 'bg-blue-500/20 text-blue-500' : message.status === 'read' ? 'bg-gray-500/20' : 'bg-green-500/20 text-green-500'}`}>{message.status}</Badge>
                </div>
                <CardDescription className="text-xs sm:text-sm break-all">{message.name} - {message.email}</CardDescription>
              </CardHeader>
              <CardContent>
                <p className="text-xs sm:text-sm text-muted-foreground mb-3">{message.message}</p>
                <div className="flex flex-wrap gap-2">
                  {message.status === 'new' && (
                    <Button size="sm" variant="outline" onClick={() => apiCall('put', `/admin/contact-messages/${message.id}?status=read`)}><Eye size={14} className="mr-1" /> Mark Read</Button>
                  )}
                  <Button size="sm" variant="outline" asChild><a href={`mailto:${message.email}?subject=Re: ${message.subject}`}><Mail size={14} className="mr-1" /> Reply</a></Button>
                  {message.status !== 'replied' && (
                    <Button size="sm" variant="outline" onClick={() => apiCall('put', `/admin/contact-messages/${message.id}?status=replied`)}><CheckCircle size={14} className="mr-1" /> Replied</Button>
                  )}
                </div>
                <Button size="sm" variant="ghost" className="w-full text-destructive hover:text-destructive text-xs mt-2" onClick={() => apiCall('delete', `/admin/contact-messages/${message.id}`)}><Trash2 size={12} className="mr-1" /> Delete</Button>
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </>
  );
};
